export default {"src":"/_next/static/media/file-bahan-ajar.b709ab25.svg","height":18,"width":14};